import React from "react";

const Ourschool = () => {
  return (
    <>
      <div className="our-school">
        <div className="our-row">
          <div className="our-col">
            <h1>About Us</h1>
            <p>
              A good school is not only a centre of education, but it is also a place where children learn the values and principles of their life. The objectives of a good school are as follows: <br /> <br />

              1. Educational Excellence: <br />

              The main objective of a good school is to provide educational excellence to students. This means providing students with in-depth knowledge in various subjects, which can help them achieve their future goals. <br /> <br />

              2. Personal Development: <br />

              The objective of a good school is also to focus on the personal development of students. This means helping students develop values such as self-confidence, communication skills, and problem-solving skills.<br /><br />

              3. Social Responsibility: <br />

              The objective of a good school is also to teach students the importance of social responsibility. This means educating students on issues such as environmental protection, community service, and social justice.<br /><br />

              4. Creativity and Innovation: <br />

              The objective of a good school is also to encourage creativity and innovation of students. This means providing students with opportunities to develop their creativity in various fields, such as art, music, and science.<br /> <br />

              5. Mental and physical health: <br />

              A good school aims to take care of the mental and physical health of students. This means teaching students the importance of healthy lifestyles, such as regular exercise, a balanced diet, and stress management.<br /><br />

              6. Vocational education <br />

              Our aim is not just to memorize things and prepare students on paper, but we want them to become financially independent in life after getting education from us.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ourschool;
